import { render } from "./StationsForm.vue?vue&type=template&id=3508a172"
import script from "./StationsForm.vue?vue&type=script&lang=js"
export * from "./StationsForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__